/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'vegan': {
    width: 960,
    height: 560,
    viewBox: '0 0 960 560',
    data: '<path pid="0" _fill="none" d="M480 540V27.8"/><path pid="1" d="M636.9 199c-68.9-68.9-144 6.6-144 6.6L480 218.2l-12.6-12.6s-35.6-35.6-80-35.5c-.6-8 0-13.9 6.6-16 45.1-7.2 32-44.1 31.3-44.1-40-2.4-44.4 43.6-44.4 43.6-22.8-78.3-81.3-49.1-81.3-49.1 4.2 67.7 40 30.5 70.7 51.2 5.3 3.2 9.3 8.3 11.3 14.2-22.3 2.1-43 12.3-58.2 28.8 0 0-68.9 68.9 6.6 144 0 0 104 104 150.3 101.4 46.6 2.4 150.3-101.4 150.3-101.4 75.2-74.8 6.3-143.7 6.3-143.7zm-97.1 72l-21.3 59.4-20.4 56.6-3.4 9.4c-1.4 3.2-2.4 5.1-6.4 5.1h-17.4c-3.1.4-6-1.8-6.4-5L450.8 357c-12.6-35.8-23.5-69-38-104.8-.6-1.1-.8-2.2-.8-3.4-.4-3.1 1.8-6 4.9-6.4.5-.1 1.1-.1 1.6 0H434c3.9 0 5 2.6 6.3 5.1l39.6 116L518.4 248v.5c1.2-3.8 3.4-5.6 6.4-5.6h16c3.4.2 6.1 2.9 6.4 6.3-.2.2-2.8 9.2-7.4 22.1v-.3z"/>'
  }
})
